import { withIdleTimer } from 'react-idle-timer';

const IdleTimerComponent = props => props.children;
const IdleTimer = withIdleTimer(IdleTimerComponent);

export default IdleTimer;
